import React, { useState } from "react";
import themestyle from "../theme";

const Footer: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const [currentYear] = useState(new Date().getFullYear());
  return (
    <div
      className="with-safe-area"
      style={{
        textAlign: "center",
        color: themestyle.colors.black,
        backgroundColor: "white",
        fontSize: "14px", 
        height: "32px", 
        lineHeight: "32px",
        fontWeight: 500,
        padding: "5px 0",
        position: "relative",
        bottom: 0,
        width: "100%",
        fontFamily: themestyle.fontFamily.Poppins,
        borderTop: "1px solid #e5e7eb",
        ...style,
      }}
    >
      <style>
        {`
          html { -webkit-text-size-adjust: 100%; text-size-adjust: 100%; }
          .responsive-footer { white-space: nowrap; }
          .mobile-break { display: none; }  /* no break on desktop */
          @supports (padding-bottom: env(safe-area-inset-bottom)) {
            .with-safe-area { padding-bottom: calc(5px + env(safe-area-inset-bottom)); }
          }
          @media (max-width: 600px) {
            .responsive-footer {
              font-size: 11px !important;
              line-height: 18px !important;
              height: auto !important;
              white-space: normal;  
              padding: 4px 8px;
            }
            .mobile-break { display: inline; }
          }
        `}
      </style>

      <div className="responsive-footer">
        © {currentYear} Designed and developed by{" "}
        <a
          href="https://pheonixsolutions.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: themestyle.colors.activeGreen, textDecoration: "none", fontWeight: 600 }}
          aria-label="Visit Pheonixsolutions website"
        >
          Pheonixsolutions
        </a>
        . <span className="mobile-break"><br /></span>All rights reserved.
      </div>
    </div>
  );
};
export default Footer;